import { CheckCircle2, Clock, FileDown } from "lucide-react";

const monthLabel = (m) => {
  const [y, mo] = m.split("-").map(Number);
  const s = new Date(y, mo - 1, 1).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const PaidBadge = ({ row, onToggle }) => {
  const cls = row.paid ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700";
  const label = row.paid ? `Payé le ${new Date(row.paid_at).toLocaleDateString("fr-FR")}` : "À verser";
  const Icon = row.paid ? CheckCircle2 : Clock;
  const content = <><Icon className="w-3.5 h-3.5" />{label}</>;
  if (!onToggle) return <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full ${cls}`} data-testid={`commission-status-${row.month}`}>{content}</span>;
  return (
    <button onClick={() => onToggle(row)} title={row.paid ? "Annuler" : "Marquer comme payé"} data-testid={`commission-toggle-${row.month}`}
      className={`inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full border ${cls} hover:opacity-80`}>
      {content}{!row.paid && " — Marquer payé"}
    </button>
  );
};

export const CommissionTable = ({ data, onToggle, showSakura, onPdf }) => {
  if (!data) return <p className="text-slate-400">Chargement...</p>;
  const pct = Math.round(data.rate * 100);
  const { current, months } = data;
  const mine = (r) => (r.base_total - r.commission).toFixed(2);
  return (
    <div className="space-y-4" data-testid="commission-table">
      <div className="rounded-xl bg-slate-900 text-white p-4" data-testid="commission-current">
        <p className="text-sm text-slate-300">Mois en cours — {monthLabel(current.month)} (estimation)</p>
        <p className="text-3xl font-bold mt-1">{current.commission.toFixed(2)} €</p>
        <p className="text-xs text-slate-300">{pct} % de {current.base_total.toFixed(2)} € ({current.deposits_count} bon(s) clients pro)</p>
        {showSakura && <p className="text-sm text-emerald-300 mt-1" data-testid="commission-current-mine">Votre part ({100 - pct} %) : {mine(current)} €</p>}
        {onPdf && (
          <button onClick={() => onPdf(current, true)} className="mt-3 inline-flex items-center gap-1 text-xs font-semibold bg-white text-slate-900 px-3 py-1.5 rounded-full" data-testid="commission-pdf-current">
            <FileDown className="w-3.5 h-3.5" />PDF du mois en cours
          </button>
        )}
      </div>
      <div className="bg-white border rounded-xl divide-y">
        {months.map((r) => (
          <div key={r.month} className="flex items-center justify-between gap-3 p-3 flex-wrap" data-testid={`commission-row-${r.month}`}>
            <div>
              <p className="font-semibold">{monthLabel(r.month)}</p>
              <p className="text-xs text-slate-500">{pct} % de {r.base_total.toFixed(2)} € — {r.deposits_count} bon(s)</p>
              {showSakura && <p className="text-xs text-emerald-700" data-testid={`commission-mine-${r.month}`}>Votre part ({100 - pct} %) : {mine(r)} €</p>}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-lg font-bold text-pink-600">{r.commission.toFixed(2)} €</span>
              <PaidBadge row={r} onToggle={onToggle} />
              {onPdf && (
                <button onClick={() => onPdf(r, false)} title="Télécharger le PDF" className="inline-flex items-center gap-1 text-xs font-semibold border px-2 py-1.5 rounded-full hover:bg-slate-50" data-testid={`commission-pdf-${r.month}`}>
                  <FileDown className="w-3.5 h-3.5" />PDF
                </button>
              )}
            </div>
          </div>
        ))}
        {months.length === 0 && <p className="text-center text-slate-400 p-4">Aucun mois clôturé pour l'instant (calcul le 1er de chaque mois à 6h)</p>}
      </div>
    </div>
  );
};
